/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  updateavatar({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_depense_avatar/${user.id}`, user)
        .then((response) => {
          
          
          // // Convert Date String to Date Object
          let userdd = response.data
          console.log('userdd',userdd)
          // commit('UPDATE_USERS', user)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
   addItem({ commit }, item) {
    console.log(item)
     return new Promise((resolve, reject) => {
      
       axios.post("https://trainingcenterback.codily.net/api/add_depense", item)
         .then((response) => {
           console.log(response.data)
           commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
           resolve(response)
         })
         .catch((error) => { reject(error) })
     })
   },
  
  fetchUsers({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/get_depenses")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  fetchSalaire({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/get_depenses_salaire")
        .then((response) => {
          commit('SET_SALAIRE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchSalaireFormateur({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_depenses_salaire_formateur/${userId}`)
        .then((response) => {
          commit('SET_SALAIRE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/remove_depense/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_depense/${user.id}`, user)
        .then((response) => {
          
          
          // Convert Date String to Date Object
          let user = response.data
          console.log(user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  
}
